import {
  DocumentOrganizationKeys,
  FilterDocument,
} from 'shared/types/filter-document';
import { SmartList } from 'shared/types/smart-list';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';

export const getDefaultFilterDocument = (
  _smartList?: SmartList,
): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Priority,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  [DocumentOrganizationKeys.Filters]: {},
});
